module.exports = __webpack_public_path__ + "static/img/zhuangshi01.bfe2b2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/zhuangshi01.png
// module id = sPDF
// module chunks = 60